var _style, _path, _polygon, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVideophone = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_4",
  viewBox: "0 0 40 26"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t\t.st0{fill:#233750;}\n\t\t.st1{fill:none;stroke:#233750;stroke-width:2;stroke-miterlimit:10;}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M22.4,15.5l-2.3-0.3c-0.5-0.1-1.1,0.1-1.5,0.5l-1.6,1.6c-2.5-1.3-4.6-3.3-5.9-5.9l1.6-1.6 c0.4-0.4,0.6-0.9,0.5-1.5l-0.3-2.2c-0.1-0.9-0.9-1.6-1.8-1.6H9.8c-1,0-1.8,0.8-1.8,1.8c0.5,7.6,6.6,13.7,14.1,14.1 c1,0.1,1.8-0.8,1.8-1.8v-1.5C24,16.3,23.3,15.6,22.4,15.5z"
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "38,3.1 38,22.3 30.2,16.7 30.2,8.7 "
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M30.2,16.2v4.6c0,1.8-1.7,3.3-3.9,3.3H4.8c-2.1,0-3.8-1.5-3.8-3.3V4.3C1,2.5,2.7,1,4.8,1h21.5 c2.1,0,3.9,1.5,3.9,3.3V16.2z"
})));
export default __webpack_public_path__ + "static/media/Videophone.a590b590.svg";
export { SvgVideophone as ReactComponent };